import { Directive, OnInit, Input, OnDestroy } from '@angular/core';
import { UtilityService } from 'src/app/services/utility/utility.service';

// The save-behaviour settings live on the root UtilityService (a singleton). Two dynamic forms
// can be alive at once (a page plus a quick-create dialog), so the directive snapshots the values
// it is about to overwrite and restores them on destroy, stack-style, instead of nulling them.
const UTILITY_KEYS = [
  'preFormSubmitJS',
  'openPopupBeforeSave',
  'openPopupBeforeSaveMessage',
  'openPopupBeforeSaveCondition',
  'redirectUrlAfterSubmit',
  'afterFormSubmitErrorJS',
  'afterFilesSaveFormAction',
  'afterSavePopup',
  'afterSavePopupText',
  'afterSavePopupCondition'
] as const;

@Directive({
    selector: '[preFormSubmit]',
    standalone: false
})
export class PreFormSubmitDirective implements OnInit, OnDestroy  {

  @Input() preFormSubmitJS: string;
  @Input() openPopupBeforeSaveMessage: string = null;
  @Input() openPopupBeforeSave: string = null;
  @Input() openPopupBeforeSaveCondition: string = null;
  @Input() redirectUrlAfterSubmit: string = null;
  @Input() afterFormSubmitErrorJS: string;
  @Input() afterFilesSaveFormAction: string;

  @Input() afterSavePopup: boolean;
  @Input() afterSavePopupText: string;
  @Input() afterSavePopupCondition: string;

  private previous: Record<string, any> = {};
  // what this directive wrote; on destroy we only restore keys nobody else has overwritten since
  private applied: Record<string, any> = {};

  constructor(private utilityService:UtilityService ) {

  }
    ngOnDestroy(): void {
        for (const key of UTILITY_KEYS) {
            // a newer form (e.g. the page after a navigation while a dialog was open) owns the value now
            if ((this.utilityService as any)[key] !== this.applied[key]) continue;
            (this.utilityService as any)[key] = this.previous[key] ?? null;
        }
    }

  ngOnInit() {
    for (const key of UTILITY_KEYS) {
      this.previous[key] = (this.utilityService as any)[key];
    }

    this.utilityService.preFormSubmitJS = this.preFormSubmitJS;
    if (this.openPopupBeforeSave == "true") {
      this.utilityService.openPopupBeforeSave = true;
    } else {
      this.utilityService.openPopupBeforeSave = false;
    }

    this.utilityService.afterFilesSaveFormAction = this.afterFilesSaveFormAction;
    this.utilityService.afterFormSubmitErrorJS = this.afterFormSubmitErrorJS;
    this.utilityService.redirectUrlAfterSubmit = this.redirectUrlAfterSubmit;
    this.utilityService.openPopupBeforeSaveMessage = this.openPopupBeforeSaveMessage;
    this.utilityService.openPopupBeforeSaveCondition = this.openPopupBeforeSaveCondition;
    this.utilityService.afterSavePopup = this.afterSavePopup;
    this.utilityService.afterSavePopupText = this.afterSavePopupText;
    this.utilityService.afterSavePopupCondition = this.afterSavePopupCondition;

    for (const key of UTILITY_KEYS) {
      this.applied[key] = (this.utilityService as any)[key];
    }
  }



}
